<modal [isOpen]="true">
  <div class="primary-modal">
    <div class="modal-passkeys">
      <div class="modal-passkeys__header">
        <span class="modal-passkeys__header__title">
          {{ translate.title }}
        </span>
        <div class="modal-passkeys__header__close" (click)="closeModal()">
          <mat-icon class="">close</mat-icon>
        </div>
      </div>
      <div class="modal-passkeys__body">
        <div class="modal-passkeys__body__img">
          <img
            src="https://cdn.mango-soft.com/access-control/passkeys-img.svg"
            alt=""
          />
        </div>
        <div class="modal-passkeys__body__text">
          <span>
            {{ translate.text }}
          </span>
        </div>
        <div class="modal-passkeys__body__steps">
          <ol>
            <li *ngFor="let step of translate.steps || []">{{ step }}</li>
          </ol>
        </div>
      </div>
      <div class="footer-modal modalAction">
        <!-- <button class="mg-button ">Save</button> -->
        <button (click)="closeModal()" class="mg-button secundaryButton">
          {{ translate.close }}
        </button>
      </div>
    </div>
  </div></modal
>
